import { TTProtection, TTProtectionFilters } from "../TTProtection";

const ttProtectionFilterDefaultValues: TTProtectionFilters = {
  SpdrClassifications: [],
  PlantGsdbs: [],
  PlantTypes: [],
  IeoPlantGsdbs: [],
  SupplierCountryIds: [],
  SupplierRegions: [],
  SupplierZipAreas: [],
  SupplierGsdbs: [],
  OdcGsdbs: [],
  CrossingCountryIds: [],
  FtlRouteNumbers: [],
};

export const ttProtectionDefaultValues: TTProtection = {
  Guid: "",
  Id: 0,
  Version: 0,
  Name: "",
  EffectiveInDate: null,
  EffectiveOutDate: null,
  OverrideTT: 0,
  OverrideCode: "-",
  OverrideRemark: "-",
  ImplementationDate: "",
  Description: "-",
  TtProtectionFilters: ttProtectionFilterDefaultValues,
  ManuallyAddedSprs: [],
  ExcludedSprs: [],
};
